import { useGetSystemSettingQuery } from '../services/nestjs-base-api';
import { useAuth } from './useAuth';

// SYR-41: gates the org-side customers / segments / integrations UI behind a
// system setting until we're ready for public rollout. Defaults to disabled —
// the value only flips on once a super admin sets CUSTOMER_SEGMENTATION_ENABLED
// to 'true' in System Settings.
export const useCustomerSegmentationEnabled = (): boolean => {
    const { user } = useAuth();

    const { data } = useGetSystemSettingQuery(
        { jwtToken: user?.jwtToken || '', settingName: 'CUSTOMER_SEGMENTATION_ENABLED' },
        { skip: !user?.jwtToken }
    );

    if (data === undefined || data === 'NOT_FOUND') return false;
    return data === 'true' || data === '1' || (data as unknown) === true;
};
